<template>
  <div class="with-dropdown">
    <roe-modal wrap-class="drop-down-menu" ref="dropdown">
      <div class="drop-down-actions">
        <ul @click="$refs.dropdown && $refs.dropdown.close()">
          <li>
            <button
              @click.stop="$emit('open-edit-name', currentDesign)"
              class="btn-link"
            >
              Rename
            </button>
          </li>
          <li>
            <button @click="archive(currentDesign)" class="btn-link">
              Archive
            </button>
          </li>
          <li>
            <button @click="remove(currentDesign.id)" class="btn-link">
              Delete
            </button>
          </li>
        </ul>
      </div>
    </roe-modal>
    <button @click.stop="$refs.dropdown.changeState()" class="btn-more">
      <span></span><span></span><span></span>
    </button>
  </div>
</template>

<script>
import RoeModal from "@/components/_shared/Modal";
import {
  ALTERNATIVE_DESIGN_ARCHIVE,
  ALTERNATIVE_DESIGN_REMOVE
} from "@/store/actions.type";
import { mapActions } from "vuex";
export default {
  name: "RoeDesignActions",
  components: { RoeModal },
  props: ["currentDesign"],
  methods: {
    ...mapActions({
      archive: ALTERNATIVE_DESIGN_ARCHIVE,
      remove: ALTERNATIVE_DESIGN_REMOVE
    })
  }
};
</script>
